<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Start Outbound Call</v-card-title>

    <v-card-text>
        <v-text-field
            label="Call"
            :value="pretty_print_target"
            disabled
            autocomplete="off"
        />

        <v-text-field
            label="From"
            :value="pretty_print_organization"
            disabled
            autocomplete="off"
        />

        <v-select
            label="Take call on (personal device)"
            :items=personal_choices
            v-model="active_personal_choice"
            return-object
        />
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            dialog: false, 

            target: null,
            organization: null,
            personal: null,

            personal_choices: [],
            active_personal_choice: null,
        }
    },

    methods: 
    {
        showDialog(organization, target) 
        {
            let profile = this.$rc.$state.profile;
            let choices = [];
            let active_choice = null;

            let personal_devices = profile.employee_account.personal_devices;
            let forward_incoming_calls = profile.employee_account.voice_settings.forward_incoming_calls;

            for ( let i = 0; i < personal_devices.length; i++ )
            {
                let cur_endpoint = personal_devices[i].endpoint;
                let pretty_print = E164.prettyPrintUsPhoneNumber(cur_endpoint);

                choices.push({
                    'text' : pretty_print+" ("+personal_devices[i].label+")",
                    'value' : cur_endpoint
                });

                if ( forward_incoming_calls === cur_endpoint )
                    active_choice = choices[choices.length-1];
            }

            choices.push({
                    'text' : 'Custom Phone Number...',
                    'value' : 'custom'
                });

            if ( active_choice === null )
                    active_choice = choices[0];
            
            this.personal_choices = choices;
            this.active_personal_choice = active_choice;


            this.organization = organization;
            this.target = target;
            
            this.dialog = true;
        },

        
        onOk()
        {
            this.dialog = false;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'POST: /bandwidth/outbound-calling/start-outbound-call',
            
                {
                    'personal' : this.active_personal_choice.value,
                    'organization' : this.organization,
                    'target' : this.target,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    if ( data.error_message != null )
                    {
                        this.$rc.alert('Unable to place call', data.error_message);
                        return;
                    }

                    this.$rc.snackbar("Your phone will ring momentarily.  Answer to place the call.");
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to place call');
                },
            );

        }
    },

    computed: {
        pretty_print_target() {
            return E164.prettyPrintUsPhoneNumber(this.target);
        },
        pretty_print_organization() {
            return E164.prettyPrintUsPhoneNumber(this.organization);
        }
    },

    watch: {
        active_personal_choice(newValue, oldValue) 
        {
            if ( newValue == null ) return;

            if ( newValue.value === 'custom' )
            {
                let value = prompt("Enter the phone number you want to use to take this outbound call");
                let endpoint = E164.createEndpointFromUSPhoneNumber(value,null);

                if ( endpoint == null )
                {
                    setTimeout(() => { this.active_personal_choice = oldValue; }, 100);
                    return;
                }

                let new_item = {
                    'text' : E164.prettyPrintUsPhoneNumber(endpoint)+" (Custom)",
                    'value' : endpoint
                };

                this.personal_choices.splice(this.personal_choices.length-2,0,new_item);

                setTimeout(() => { this.active_personal_choice = new_item; }, 100);
            }    
        }
    },
}
</script>

<style lang="scss" scoped>

</style>